var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVnet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vnet_svg__a",
    x1: 9.88,
    y1: 8.59,
    x2: 11.52,
    y2: 10.23,
    gradientTransform: "rotate(-.08 -285.464 -1454.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vnet_svg__b",
    x1: 6.18,
    y1: 8.59,
    x2: 7.81,
    y2: 10.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vnet_svg__c",
    x1: 2.48,
    y1: 8.59,
    x2: 4.11,
    y2: 10.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86d633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5e9624"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.74,
    cy: 8.99,
    r: 1.16,
    fill: "url(#vnet_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.04,
    cy: 9,
    r: 1.16,
    fill: "url(#vnet_svg__b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.34,
    cy: 9,
    r: 1.16,
    fill: "url(#vnet_svg__c)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.182 13.638l-.664.665a.3.3 0 01-.424 0L.18 9.404a.6.6 0 01-.001-.848l.663-.666 5.34 5.324a.3.3 0 010 .425z",
    fill: "#50e6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.418 3.708l.666.664a.3.3 0 010 .424L.838 10.057l-.666-.663a.6.6 0 01-.001-.849L4.994 3.71a.3.3 0 01.424 0z",
    fill: "#1490df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.157 7.88l.663.666a.6.6 0 010 .848l-4.915 4.9a.3.3 0 01-.424 0l-.664-.666a.3.3 0 010-.424l5.34-5.324z",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.818 9.387l-.665.664-5.247-5.261a.3.3 0 010-.425l.674-.67a.3.3 0 01.424 0l4.823 4.836a.6.6 0 01-.002.849z",
    fill: "#1490df"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSI5Ljg4IiB5MT0iOC41OSIgeDI9IjExLjUyIiB5Mj0iMTAuMjMiIGdyYWRpZW50VHJhbnNmb3JtPSJyb3RhdGUoLS4wOCAtMjg1LjQ2NCAtMTQ1NC4wOCkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjODZkNjMzIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNWU5NjI0Ii8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJiIiB4MT0iNi4xOCIgeTE9IjguNTkiIHgyPSI3LjgxIiB5Mj0iMTAuMjMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjODZkNjMzIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzVlOTYyNCIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iYyIgeDE9IjIuNDgiIHkxPSI4LjU5IiB4Mj0iNC4xMSIgeTI9IjEwLjIzIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzg2ZDYzMyIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM1ZTk2MjQiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxjaXJjbGUgY3g9IjEyLjc0IiBjeT0iOC45OSIgcj0iMS4xNiIgZmlsbD0idXJsKCNhKSIvPgogIDxjaXJjbGUgY3g9IjkuMDQiIGN5PSI5IiByPSIxLjE2IiBmaWxsPSJ1cmwoI2IpIi8+CiAgPGNpcmNsZSBjeD0iNS4zNCIgY3k9IjkiIHI9IjEuMTYiIGZpbGw9InVybCgjYykiLz4KICA8cGF0aCBkPSJNNi4xODIgMTMuNjM4bC0uNjY0LjY2NWEuMy4zIDAgMDEtLjQyNCAwTC4xOCA5LjQwNGEuNi42IDAgMDEtLjAwMS0uODQ4bC42NjMtLjY2NiA1LjM0IDUuMzI0YS4zLjMgMCAwMTAgLjQyNXoiIGZpbGw9IiM1MGU2ZmYiLz4KICA8cGF0aCBkPSJNNS40MTggMy43MDhsLjY2Ni42NjRhLjMuMyAwIDAxMCAuNDI0TC44MzggMTAuMDU3bC0uNjY2LS42NjNhLjYuNiAwIDAxLS4wMDEtLjg0OUw0Ljk5NCAzLjcxYS4zLjMgMCAwMS40MjQgMHoiIGZpbGw9IiMxNDkwZGYiLz4KICA8cGF0aCBkPSJNMTcuMTU3IDcuODhsLjY2My42NjZhLjYuNiAwIDAxMCAuODQ4bC00LjkxNSA0LjlhLjMuMyAwIDAxLS40MjQgMGwtLjY2NC0uNjY2YS4zLjMgMCAwMTAtLjQyNGw1LjM0LTUuMzI0eiIgZmlsbD0iIzUwZTZmZiIvPgogIDxwYXRoIGQ9Ik0xNy44MTggOS4zODdsLS42NjUuNjY0LTUuMjQ3LTUuMjYxYS4zLjMgMCAwMTAtLjQyNWwuNjc0LS42N2EuMy4zIDAgMDEuNDI0IDBsNC44MjMgNC44MzZhLjYuNiAwIDAxLS4wMDIuODQ5eiIgZmlsbD0iIzE0OTBkZiIvPgo8L3N2Zz4=";
export { SvgVnet as ReactComponent };